<div
  ngbDropdown
  #dateDropdown="ngbDropdown"
  class="date-dropdown"
  placement="bottom-left"
  display="dynamic"
  [class.is-mobile]="isMobile"
  [autoClose]="isMobile ? false : 'outside'"
  (openChange)="onDateDropdownOpenChange($event)"
>
  <span class="dropdown-anchor" ngbDropdownAnchor></span>

  <div
    *ngIf="isMobile"
    class="input-container"
    (click)="onFromDateFocus($event, dateDropdown)"
  >
    <app-input
      [fc]="selectedDateFromAndToControl"
      placeholder="Add dates"
      [readonly]="true"
    ></app-input>
  </div>

  <ng-container *ngIf="!isMobile">
    <div
      class="field-container"
      [class.active]="focusOn === 'from'"
      (click)="onFromDateFocus($event, dateDropdown)"
    >
      <span class="field-label">From</span>

      <span class="field-input">{{ fromValue }}</span>
    </div>

    <div
      class="field-container"
      [class.active]="focusOn === 'to'"
      (click)="onToDateFocus($event, dateDropdown)"
    >
      <span class="field-label">To</span>

      <span class="field-input">{{ toValue }}</span>
    </div>
  </ng-container>

  <div
    class="date-dropdown__container"
    ngbDropdownMenu
  >
    <nav class="date-dropdown__nav d-flex">
      <ul
        ngbNav
        [(activeId)]="active"
        (activeIdChange)="onCalendarModeChange($event)"
        class="nav-pills"
        orientation="vertical"
      >
        <li [ngbNavItem]="SEARCH_DATE_DROPDOWN_DATE_RANGE.TODAY">
          <a ngbNavLink>Today</a>
        </li>
        <li [ngbNavItem]="SEARCH_DATE_DROPDOWN_DATE_RANGE.WEEKEND">
          <a ngbNavLink>This weekend</a>
        </li>
        <li [ngbNavItem]="SEARCH_DATE_DROPDOWN_DATE_RANGE.NEXT_WEEKEND">
          <a ngbNavLink>Next weekend</a>
        </li>
        <li [ngbNavItem]="SEARCH_DATE_DROPDOWN_DATE_RANGE.WEEK">
          <a ngbNavLink>This week</a>
        </li>
        <li [ngbNavItem]="SEARCH_DATE_DROPDOWN_DATE_RANGE.NEXT_WEEK">
          <a ngbNavLink>Next week</a>
        </li>
        <li [ngbNavItem]="SEARCH_DATE_DROPDOWN_DATE_RANGE.MONTH">
          <a ngbNavLink>This month</a>
        </li>
        <li [ngbNavItem]="SEARCH_DATE_DROPDOWN_DATE_RANGE.YEAR">
          <a ngbNavLink>This year</a>
        </li>
        <li [ngbNavItem]="SEARCH_DATE_DROPDOWN_DATE_RANGE.CUSTOM">
          <a ngbNavLink>Custom</a>
        </li>
      </ul>
    </nav>

    <ng-template #t let-date let-focused="focused">
      <span
        class="custom-day"
        [class.focused]="focused"
        [class.range]="isRange(date)"
        [class.faded]="isHovered(date) || isInside(date)"
        (mouseenter)="hoveredDate = date"
        (mouseleave)="hoveredDate = null"
      >
        {{ date.day }}
      </span>
    </ng-template>

    <div>
      <app-datepicker
        #dp
        [minDate]="today"
        [displayMonths]="isMobile ? 1 : 2"
        [dayTemplate]="t"
        navigation="arrows"
        outsideDays="hidden"
        (dateSelect)="onDateSelection($event)"
      ></app-datepicker>

      <div class="date-dropdown__buttons" *ngIf="!isMobile">
        <app-button buttonStyle="white" (click)="onClearClick()"> Clear </app-button>
        <app-button buttonStyle="black" (click)="dateDropdown.close()"> Apply </app-button>
      </div>
    </div>
  </div>
</div>
